import { cx } from 'class-variance-authority';
import type { ClassValue } from 'class-variance-authority/types';
import { extendTailwindMerge } from 'tailwind-merge';

// Tailwind Merge helps prevent conflicting tailwind classes.
// Because we are overwriting the default styles in index.css, we need to inform tailwind-merge about our custom classes.
const twMerge = extendTailwindMerge({
  override: {
    theme: {
      text: ['display', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', '20', '18', '16', '14', '13', '12'],
      'font-weight': ['light', 'regular', 'medium', 'semibold', 'bold', 'extrabold', 'black'],
      radius: ['none', 'sm', 'md', 'lg', 'xl', 'full'],
      shadow: ['xs', 'sm', 'md', 'lg', 'none'],
    },
  },
});

/**
 * Utility function for merging Tailwind CSS classes
 * Uses clsx to handle conditional classes and tailwind-merge to properly merge conflicting classes
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(cx(inputs));
}
